import { overlay } from 'overlay-kit';
import { QuizSetupModal, type QuizSetupModalProps } from './components';
export { useShowQuizSetupModal } from './hooks';

// ============================================================================
// Modal wrapper (기존 코드 호환성을 위한 export)
// ============================================================================

/**
 * 신규 퀴즈 생성 모달 오픈 (overlay-kit)
 */
export const quizSetupModal = {
  openAsync({
    mapTemplates,
    selectedMapTemplateId,
    initialCategoryInfoValues,
    schoolInfoTree,
    subjectTree,
    publishers,
    userCountryCode,
    buildType,
    onMapComplete,
    onCategoryInfoComplete
  }: QuizSetupModalProps) {
    return overlay.openAsync(({
      unmount
    }) => <QuizSetupModal mapTemplates={mapTemplates} selectedMapTemplateId={selectedMapTemplateId} initialCategoryInfoValues={initialCategoryInfoValues} schoolInfoTree={schoolInfoTree} subjectTree={subjectTree} publishers={publishers} userCountryCode={userCountryCode} buildType={buildType} onMapComplete={onMapComplete} onCategoryInfoComplete={values => {
      onCategoryInfoComplete(values);
      unmount();
    }} />);
  }
};